import {
	Component,
	Input,
	OnInit,
	AfterContentChecked,
	inject,
	Output,
	EventEmitter,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
	ItTabContainerComponent,
	ItTabItemComponent,
	ItModalComponent,
	ItInputComponent,
	ItSelectComponent,
	ItButtonDirective,
} from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import { AmendmentsComponent } from '../amendments/amendments.component';
import { StepComponent } from '../step/step.component';
import type { Authority } from '../interfaces/authority';
import type { Dossier } from '../interfaces/dossier';
import type { Phase } from '../interfaces/phase';
import type { Step } from '../interfaces/step';

@Component({
	selector: 'app-phase',
	imports: [
		FormsModule,
		ItTabContainerComponent,
		ItTabItemComponent,
		ItModalComponent,
		ItInputComponent,
		ItSelectComponent,
		ItButtonDirective,
		StepComponent,
		TranslateModule,
		AmendmentsComponent,
	],
	templateUrl: './phase.component.html',
	styleUrl: './phase.component.scss',
})
export class PhaseComponent implements OnInit, AfterContentChecked {
	private router = inject(Router);
	private activatedRoute = inject(ActivatedRoute);
	private iterlexService = inject(IterlexService);

	wasLoaded = false;
	tabPrefix = 'step-';
	currentStepId = '';
	steps: Step[] = [];
	commissions: Authority[] = [];
	@Input({ required: true }) dossier!: Dossier;
	@Input({ required: true }) authority!: Authority;
	@Input({ required: true }) body!: Authority;
	@Input({ required: true }) phase!: Phase;
	@Input({ required: true }) active!: boolean;
	@Input({ required: true }) phaseTabPrefix!: string;
	@Output() sendedToStagingAreaEvent = new EventEmitter();
	ngOnInit() {
		if (this.phase.type == 'commissione') {
			this.iterlexService.getAuthorities().subscribe((authorities) => {
				for (const authority of authorities) {
					if (authority.children.length > 0) {
						const commissionAuthority = authority.children.find(
							(authority) => authority.id == 'commissione',
						);
						if (commissionAuthority) {
							this.commissions = commissionAuthority.children;
							break;
						}
					}
				}
			});
		}
	}
	ngAfterContentChecked(): void {
		if (this.active && !this.wasLoaded) {
			this.wasLoaded = true;
			this.iterlexService
				.getSteps(
					this.authority.id,
					this.body.id,
					this.dossier.workUri,
					this.phase.id,
				)
				.subscribe(async (steps) => {
					if (this.phase.type == 'emendamento') {
						this.steps = steps.sort((a, b) => a.order - b.order);
					}
					this.steps = steps;
					if (this.steps.length > 0) {
						const stepQueryParams =
							this.activatedRoute.snapshot.queryParamMap.get(
								'step',
							);
						if (stepQueryParams) {
							this.currentStepId = stepQueryParams;
						} else {
							// Ignore steps without expressions
							let maxDocumentExpressionCount = 1;
							// If there aren't expressions open the first step
							let stepId = steps[0].id;
							for (const step of steps) {
								if (
									step.documentExpressionsCount >=
									maxDocumentExpressionCount
								) {
									maxDocumentExpressionCount =
										step.documentExpressionsCount;
									stepId = step.id;
								}
							}
							this.currentStepId = stepId;
						}
					}
				});
		}
		if (!this.active && this.wasLoaded) {
			this.wasLoaded = false;
		}
	}
	changeTab(tab: ItTabItemComponent) {
		this.changeCurrentStepId(tab.id.replace(this.tabPrefix, ''));
	}
	setCurrentPhase(phaseId: string) {
		this.iterlexService
			.createDossierExpression(
				this.authority.id,
				this.body.id,
				this.dossier.workUri,
				this.dossier.author,
				this.dossier.title,
				new Date().toISOString(),
				phaseId,
			)
			.subscribe((dossierExpression) => {
				document
					.getElementsByClassName('nav-link current-phase')[0]
					?.classList.remove('current-phase');
				document
					.getElementById(
						this.phaseTabPrefix +
							dossierExpression.phaseId +
							'-tab-link',
					)
					?.classList.add('current-phase');
			});
	}
	onCreateStepSubmit(form: NgForm) {
		if (form.valid) {
			if (this.phase.type == 'commissione') {
				const commission = this.commissions.find(
					(commission) => commission.id == form.value.assignedBody,
				);
				form.value.descriptionITA = commission!.label['it'];
				form.value.descriptionDEU = commission!.label['de'];
			}
			if (this.phase.label['it'].toLowerCase().includes('assemblea')) {
				form.value.assignedBody = 'assemblea';
			}
			this.iterlexService
				.createStep(
					this.dossier.workUri,
					this.authority.id,
					this.body.id,
					this.phase.id,
					form.value.descriptionITA,
					form.value.descriptionDEU,
					this.steps.length + 1,
					form.value.assignedBody,
				)
				.subscribe((step) => {
					console.log(step);
					this.iterlexService
						.getSteps(
							this.authority.id,
							this.body.id,
							this.dossier.workUri,
							this.phase.id,
						)
						.subscribe((steps) => {
							if (steps.length > 0) {
								this.steps = steps;
								this.currentStepId = steps.at(-1)!.id;
							}
						});
				});
		}
	}
	changeCurrentStepId(newCurrentStepId: string) {
		this.currentStepId = newCurrentStepId;
		this.router.navigate([], {
			queryParams: { step: this.currentStepId },
			queryParamsHandling: 'merge',
		});
	}
	deleteStepEvent(deletedStep: Step) {
		this.steps.splice(this.steps.indexOf(deletedStep), 1);
	}
}
